<template>
    <div :class="pageCls" :id="!isExist && 'mi-detail-error'">
        <template v-if="!onLine">
            <a class="no-net-tip" @click="reload">
                <i class="iconfont icon-wifi"></i>
                <span class="text">{{loading ? '等' : '没网'}}</span>
            </a>
        </template>
        <template v-else-if="!isExist">
            <span class="no-data-tip">
                <span class="text">这篇文章找不到了</span>
            </span>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        onLine: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        isExist: {
            type: Boolean,
            default: true
        },
        wrapCls: {
            type: Array,
            default() {
                return [];
            }
        },
        reload: {
            type: Function,
            default() {
                return function() {};
            }
        }
    },
    computed: {
        pageCls() {
            let cls = ['p-common', ...[this.wrapCls]];
            if(!this.isExist) {
                cls.push('p-empty');
            }
            return cls;
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/common/page/common.vue